import React, { useEffect, useState } from 'react';
import { AppearanceContext } from './AppearanceContext';
import { readAppearanceCache } from './appearanceCache';
import type { AppearanceConfig } from './appearance';
import AppLoadingFallback from '../components/AppLoadingFallback';

export default function AppearanceProvider({ children }: { children: React.ReactNode }) {
  const [snapshot, setSnapshot] = useState<{ config: AppearanceConfig | null } | null>(null);
  useEffect(() => {
    let mounted = true;
    readAppearanceCache().then((config) => { if (mounted) setSnapshot({ config }); });
    return () => { mounted = false; };
  }, []);
  if (!snapshot) return <AppLoadingFallback />;
  return <AppearanceContext.Provider value={snapshot.config}>{children}</AppearanceContext.Provider>;
}
